import { Center, Box } from '@chakra-ui/react'
import { UserLayout } from '@components/Layouts/UserLayout'
import { OrganisationPicker } from '@features/organisations/components/OrganisationPicker'
import { core, firebaseClientInitConfig } from '@lib/firebase/config'
import tenantManager from '@lib/firebase/tenantManager'
import { createFileRoute, redirect } from '@tanstack/react-router'

const SelectOrgRoute = () => (
  <UserLayout>
    <Box w="lg">
      <Center m={5}>Select your organisation</Center>
      <OrganisationPicker />
    </Box>
  </UserLayout>
)

export const Route = createFileRoute('/_auth/o/')({
  component: SelectOrgRoute,
  beforeLoad: async () => {
    const isStaff = tenantManager.isCurrentTenant(
      firebaseClientInitConfig.tenantIds.staff
    )
    if (isStaff) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect({
        to: core.staffAppPageUrl,
        search: { redirect: window.location.href },
      })
    }
  },
})
